const isMobileDevice = (viewPort) => /(X)?S/.test(viewPort || "");
export {
  isMobileDevice
};
